import { createTheme } from "@mui/material"

// usefeul tool for grading colors (keep url params)
// https://hihayk.github.io/scale/#4/5/60/80/0/0/20/0/D6002A/214/0/42/black
const theme = createTheme({
  palette: {
    text: {
      disabled: "rgba(0, 0, 0, 0.55)",
    },
    primary: {
      50: "#CCCCCC",
      100: "#A3A3A3",
      200: "#7A7A7A",
      300: "#525252",
      400: "#292929",
      500: "#000000", // <- default when using e.g. color="primary"
      600: "#000000",
      700: "#000000",
      800: "#000000",
      900: "#000000",
      contrastText: "#ffffff",
    },
    error: {
      50: "#FBCCD2",
      100: "#F6A3AF",
      200: "#F07A8C",
      300: "#E9526B",
      400: "#E0294A",
      500: "#D6002A", // <- default when using e.g. color="error"
      600: "#B60024",
      700: "#96001D",
      800: "#760017",
      900: "#560011",
      contrastText: "#ffffff",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          whiteSpace: "pre-line",
        },
      },
    },
    MuiAccordion: {
      variants: [
        {
          props: { variant: "section" },
          style: ({ theme }) => ({
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: theme.shape.borderRadius,
            margin: 0,
            "&.Mui-expanded": { margin: 0 },
            "& + &": { marginTop: theme.spacing(2) },
            overflow: "hidden",
            "&:before": { display: "none" },
            "& > .MuiAccordionSummary-root": {
              backgroundColor: theme.palette.grey[200],
              borderBottom: `1px solid ${theme.palette.divider}`,
              paddingInline: theme.spacing(1),
            },
            "& > .MuiAccordionSummary-root > .MuiAccordionSummary-content": {
              marginBlock: theme.spacing(1),
            },
            "& > .MuiAccordionSummary-root .MuiGrid-container": { margin: 0, padding: 0 },
            "& > .MuiAccordionDetails-root": {
              paddingBlock: theme.spacing(1.5),
              paddingInline: theme.spacing(1),
            },
          }),
        },
      ],
    },
  },
})
export default theme
